import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import {  interval } from 'rxjs';

import { SubSink } from 'subsink';

import { VERSION_UPDATE_POLLING_FREQUENCY_IN_MS } from './global.constants';
import { MS_TEN_MINUTES } from './time';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {

  newVersionDetected = false;
  newVersionReady = false;
  newVersionInstallFailed = false;
  showNewVersionModal = false;
  updating = false;

  subs = new SubSink();

  constructor(private swUpdate: SwUpdate) {}

  watchForUpdates() {
    this.subs.unsubscribe();
    this.subs.sink = this.swUpdate.versionUpdates
      .subscribe((e) => {
        console.log(`[SW DEBUG]`, e);
        if (e.type === 'VERSION_DETECTED') {
          this.newVersionDetected = true;
        } else if (e.type === 'VERSION_READY') {
          this.newVersionReady = true;
          this.showNewVersionModal = true;
          const forcedReloadKey = 'sw-forced-reload-done';
          if (!sessionStorage.getItem(forcedReloadKey)) {
            sessionStorage.setItem(forcedReloadKey, '1');
            console.log('[SW DEBUG] Forcing reload for new version');
            window.location.reload();
            return;
          }
        } else if (e.type === 'VERSION_INSTALLATION_FAILED') {
          this.newVersionInstallFailed = true;
        }

      });

    // Subscribe to updates in the online status

    // Poll for updates every 15 minutes after waiting for the app to stabalize
    // const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
    const updatePollingSubscription$ = interval(VERSION_UPDATE_POLLING_FREQUENCY_IN_MS);

    this.subs.sink = updatePollingSubscription$.subscribe(async () => {
      try {
        await this.swUpdate.checkForUpdate();
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }
    });

    this.subs.sink = this.swUpdate.unrecoverable.subscribe((event) => {
      console.warn(`[SW DEBUG] Unrecoverable: ${event.reason}`, event);
      // Requirement: attempt hard reload if sw stuck in unrecoverable state
      // attempt one hard reload per session to avoid stucking in reloading loop
      // if issue that caused unrecoverable problem survives reload
      const unrecoverableReloadKey = 'sw-unrecoverable-reload-attempted';
      if (!sessionStorage.getItem(unrecoverableReloadKey)) {
        sessionStorage.setItem(unrecoverableReloadKey, '1');
        window.location.reload();
        return;
      }
    });
  }

  updateApplication(): void {
    this.updating = true;
    window.location.reload();
  }

  dismissVersionUpdate() {
    this.showNewVersionModal = false;
    console.log(`[SW DEBUG] Update snoozed ten minutes`);

    setTimeout(() => {
      if (this.newVersionReady) {
        this.showNewVersionModal = true;
      }

    }, MS_TEN_MINUTES)

  }
}
